export const apiErrorMessage = (e, fallback = 'Ошибка при запросе к серверу') => {
	const detail = e?.response?.data?.detail;
	if (typeof detail === 'string') return detail;
	if (Array.isArray(detail)) return detail.map((item) => item.msg || String(item)).join('; ') || fallback;
	return e?.response ? fallback : (e?.message || fallback);
};
